import $ from 'jquery';
import { Sticky } from 'foundation-sites';

window.addEventListener('load', function(event) {

  let stickySearch = $('.js-sellers-search');

  if (stickySearch.length) {
    // Sticky sellers map
    const stickyMapOptions = {anchor: 'js-sellers-list', marginTop: 4.375, stickyOn: 'large'};
    const stickyMap = new Sticky($('.js-sellers-map'), stickyMapOptions);

    // Sticky sellers search
    const stickySearchOptions = {anchor: 'js-sellers-list', marginTop: 4.375, stickyOn: 'large'};
    stickySearch = new Sticky($('.js-sellers-search'), stickySearchOptions);
  }

});


